module.exports = __webpack_public_path__ + "images/jumpstart-2023-pricing-banner-mobile.jpg";